export default __webpack_public_path__ + "static/ph-6-6-sale-subbanner-mobile-ea25152848ce5a5b682095a06c111b4f.webp";